import { parseISO, startOfMonth, endOfMonth, eachDayOfInterval, format, addMonths } from 'date-fns';

export const toMonthStart = (dateStr) => {
  if (!dateStr) return format(startOfMonth(new Date()), 'yyyy-MM-dd');
  const d = parseISO(dateStr);
  return format(startOfMonth(d), 'yyyy-MM-dd');
};

export const getMonthDays = (dateStr) => {
  const d = dateStr ? parseISO(dateStr) : new Date();
  const start = startOfMonth(d);
  const end = endOfMonth(d);
  return eachDayOfInterval({ start, end }).map(day => format(day, 'yyyy-MM-dd'));
};

export const shiftMonthStart = (monthStartDateStr, deltaMonths) => {
  const d = parseISO(toMonthStart(monthStartDateStr));
  return format(startOfMonth(addMonths(d, deltaMonths)), 'yyyy-MM-dd');
};
